import moment from 'moment';
import { useEffect, useMemo, useRef, useState } from 'react';
import { BiChevronDown } from 'react-icons/bi';
import { BsHeadset } from 'react-icons/bs';
import { IoAlertOutline } from 'react-icons/io5';
import {
  HistoricClient,
  Menu,
  Modal,
  NoteClient,
  ProfileClient,
  VideoCallStatus
} from '../../../../../../../../components';
import { useChat } from '../../../../../../../../contexts/chat';
import { useOutsideAlerter } from '../../../../../../../../hooks';
import { convertChats } from '../../../../../../../../service/serviceChat/chatService';
import { maskDate, maskZero } from '../../../../../../../../utils';
import { Container, Content, Date, IconDown, Line, Name, Tag } from './styled';

export function Card(props) {

  const refMenu = useRef();

  const { data, active, load } = props;
  const { handOpenPreview } = useChat('');

  const [dateStarted, setDateStarted] = useState('');
  const [dateFinished, setDateFinished] = useState('');
  const [profileOpen, setProfileOpen] = useState(false);
  const [openHistoric, setOpenHistoric] = useState(false);
  const [noteOpen, setNoteOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  useOutsideAlerter(refMenu, handleCloseMenu);

  useEffect(() => {
    const dateStart = maskDate(data.started_at);
    setDateStarted(dateStart);
    const dateFiend = maskDate(data.started_at);
    setDateFinished(dateFiend)
  }, [data])

  function handleOpenNote() {
    setNoteOpen(true);
  }
  function handleCloseNote() {
    setNoteOpen(false);
  }

  async function handOpenChat() {
    await convertChats(data.client_phone);
    handOpenPreview(data, data.client_name, 5);
  }

  function handleOpenMenu(e) {
    setAnchorEl(e?.currentTarget)
  };

  function handleCloseMenu() {
    setAnchorEl(null);
  };

  function handleOpenProfile() {
    handleCloseMenu();
    setProfileOpen(true);
  };

  function handleOpenHistoric() {
    handleCloseMenu();
    setOpenHistoric(true)
  };

  function handleCloseProfile() {
    setProfileOpen(false);
  };

  const isNote = (note) => {
    if (note === undefined || !note || note === null || note === " " || note === "undefined" || note === "null") {
      return false
    } else {
      return true
    }
  }
  
  return (
    <>
      <Container active={active}>
        <Content>
          <Line onClick={() => handOpenChat()}>
            <Name>
              <span>{data.client_name}</span>
            </Name>
            <Date>
              <span>{dateStarted + ' - ' + moment(data.started_at).format('HH:mm')}</span>
              <span>{dateFinished + ' - ' + moment(data.finished_at).format('HH:mm')}</span>
            </Date>
          </Line>
          <Line>
            <div className='infoUser' onClick={() => handOpenChat()}>
              <Tag type='inFo'>
                {maskZero(data.id)}
              </Tag>
              <Tag type='inFo'>
                <span><BsHeadset /></span>
                <p>{data.nomecompleto}</p>
              </Tag>
            </div>
            <div className='icon-line'>
              {isNote(data.note) &&
                <Tag type='note'>
                  <IoAlertOutline className='iconNoteInline' onClick={() => handleOpenNote()} />
                </Tag>
              }
              <IconDown>
                <BiChevronDown onClick={(e) => handleOpenMenu(e)} />
              </IconDown>
            </div>
          </Line>
          {data.type === 'VIDEOCHAMADA' &&
            <Line>
              <VideoCallStatus dataCall={data?.link} />
            </Line>
          }
          <Modal title={'Anotação'} isOpen={noteOpen} close={() => handleCloseNote()}>
            {noteOpen && <NoteClient idNote={data.id} />}
          </Modal>
          <Modal title={'Histórico de Atendimento'} isOpen={openHistoric} close={() => setOpenHistoric(!openHistoric)}>
            {openHistoric && <HistoricClient client={data} />}
          </Modal>
        </Content>
        <Menu anchorEl={anchorEl} ref={refMenu}>
          <li onClick={() => handleOpenProfile()}>
            Ver Perfil
          </li>
          <li onClick={() => handleOpenHistoric()}>
            Histórico de Atendimento
          </li>
        </Menu>
      </Container>
      {profileOpen &&
        <ProfileClient client={data} name={data?.client_name} isOpen={profileOpen} close={() => handleCloseProfile()} load={load} />
      }
    </>
  );
}